import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';
import fa from 'vuetify/src/locale/fa';

Vue.use(Vuetify);

export default new Vuetify({
  icons: {
    iconfont: 'mdi' // 'mdi' || 'mdiSvg' || 'md' || 'fa' || 'fa4' || 'faSvg'
  },
  rtl: true,
  theme: {
    options: {
      customProperties: true
    },
    themes: {
      light: {
        primary: '#3C8AFF',
        secondary: '#4662B2', //202020 4662B2
        accent: '#FFC107',
        error: '#FF5252',
        info: '#C0E9FB',
        success: '#4CAF50',
        warning: '#F78A8A'
      }
    }
  },
  lang: {
    locales: { fa },
    current: 'fa'
  }
});
